import React, { memo, useEffect, useState } from "react";
import { Col, Form, Row, message } from "antd";
import Component from "Components";
import { useDispatch, useSelector } from "react-redux";
import { Community } from "../../../redux/Actions";
import Spinner from "Components/Spinner/Spiner";
import Validation from "utils/Validation";
import PropTypes from "prop-types";
import SwitchInput from "Components/Switch/Switch";

const { TextInput, SelectBox, Button } = Component;

const CommunityForm = ({ onCancel, users, community, HandleOnChange, isEdit, disabled, onUpdateSuccess }) => {
  const validationRules = Validation.getValidation([
    "communityId", "address", "phone", "residentConatactKey", "residentKey"
  ]);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const {  getCommunityById, loading } = useSelector((state) => state?.Communitys);
  const [statusValue, setStatusValue] = useState(false);
 
  useEffect(() => {
    if (getCommunityById) {
      const preservedFieldValue = form.getFieldValue("communityId");

      form.resetFields();
      form.setFieldsValue({ communityId: preservedFieldValue });

      form.setFieldsValue(getCommunityById);
      // Set status value from the data
      if (getCommunityById.isActive !== undefined) {
        setStatusValue(getCommunityById.isActive);
      }
    }
  }, [getCommunityById, form]);
  
  useEffect(() => {
    // Set initial status value from users prop
    if (users?.isActive !== undefined) {
      setStatusValue(users.isActive);
    }
  }, [users]);

  const onSearch = (value) => {
    console.log("search:", value);
  };

  const filterOption = (input, option) =>
    (option?.children ?? "").toLowerCase().includes(input.toLowerCase());

  const handleFinish = (values) => {
    const req = {
      Id: users?.id,
      CommunityId: values?.communityId,
      Address: values?.address,
      ResidentContactKey: values?.residentContactKey,
      Phone: values?.phone,
      ResidentKey: values?.residentKey,
      IsActive: statusValue
    };
    let allRequest = {
      request: req,
      handleRes: handleRes
    };
    dispatch(Community.EditCommunityByIdRequest(allRequest));
  };
  
  const handleStatusChange = (name, event) => {
    const value = event.target.value;
    setStatusValue(value);
  };

  const handleRes = (response) => {
      const resMessage = response?.data;

      // Define reusable function for success/cancel handling
      const finish = () => {
          if (onUpdateSuccess) onUpdateSuccess();
          else onCancel();
      };

      // Define reusable function for showing messages
      const showMessage = (type, content) => {
          message[type]({
              content,
              duration: 3,
              style: { marginTop: '2vh' },
          });
      };

      switch (resMessage) {
          case 'Status is populated from VMS as expected.':
              showMessage('info', resMessage);
              finish();
              break;

          case 'Updated Successfully':
              showMessage('success', resMessage);
              finish();
              break;

          default:
              if (resMessage) finish();
              break;
      }
  };


  return (
    <>
      {loading && <Spinner />}
      <div style={{ background: '#ffffff', padding: '25px 30px 20px 30px' }}>
        <Form
          layout="vertical"
          className="ant-form"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          initialValues={getCommunityById}
          onFinish={handleFinish}
          form={form}
        >
          <Row justify={'space-between'}>
            <Col sm={7}>
              <SelectBox
                disabled={disabled}
                options={community ?? []}
                className="user-form-input"
                name="communityId"
                placeholder="Community Name"
                showSearch={true}
                label="Community"
                onSearch={onSearch}
                filterOption={filterOption}
                size="md"
                rules={disabled ? [] : validationRules.communityId} hasFeedback={true} validateTrigger={"onChange"}
                onChange={HandleOnChange}
              />
            </Col>
            <Col sm={7}>
              <TextInput disabled={disabled} label="Address" name="address" placeholder="Address" rules={disabled ? [] : validationRules.address} hasFeedback={true} validateTrigger={"onChange"} />
            </Col>
            <Col sm={7}>
              <TextInput disabled={disabled} label="Phone" name="phone" placeholder="Phone" rules={disabled ? [] : validationRules.phone} hasFeedback={true} validateTrigger={"onChange"} />
            </Col>
            <Col sm={7}>
              <TextInput disabled={disabled} label="Resident Key" name="residentKey" placeholder="Resident Key" rules={disabled ? [] : validationRules.residentKey} hasFeedback={true} validateTrigger={"onChange"} />
            </Col>
              <Col sm={7}>
                <SwitchInput 
                  disabled={disabled}
                  label="Status" 
                  name="isActive" 
                  value={statusValue}
                  onChange={handleStatusChange}
                />
                <p style={{marginTop : '-20px'}} title="Status">{statusValue ? 'Active' : 'InActive'}</p>
              </Col>
            <Col sm={7}>
              <TextInput disabled={disabled} label="Resident Contact Key" name="residentContactKey" placeholder="Resident Contact Key" rules={disabled ? [] : validationRules.residentConatactKey} hasFeedback={true} validateTrigger={"onChange"} />
            </Col>
            <Col sm={24} className="create-button-content">
              {!disabled && <Button htmlType="submit" title={isEdit ? "Update" : "Create"} className="create-button" />}
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

CommunityForm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  users: PropTypes.object.isRequired, 
  community: PropTypes.array.isRequired, 
  HandleOnChange: PropTypes.func.isRequired, 
  isEdit: PropTypes.bool.isRequired, 
  disabled: PropTypes.bool.isRequired,
  onUpdateSuccess: PropTypes.func,
};

export default memo(CommunityForm);
